export default {"src":"/_next/static/media/image 7.27d88e05.svg","height":57,"width":57,"blurWidth":0,"blurHeight":0};